import React, { useState } from 'react';

const KeywordInput = ({ field, formData, setFormData }) => {
  const tagColors = ['bg-blue-100 text-blue-800', 'bg-green-100 text-green-800', 'bg-purple-100 text-purple-800', 'bg-yellow-100 text-yellow-800', 'bg-red-100 text-red-800'];
  const [currentKeywordInput, setCurrentKeywordInput] = useState('');
  const tags = Array.isArray(formData[field?.name]) ? formData[field.name] : [];

  const handleKeywordInputChange = (e) => {
    const value = e.target.value;
    setCurrentKeywordInput(value);
  };

  const handleAddKeyword = (keywordToAdd) => {
    const newKeyword = keywordToAdd || currentKeywordInput.trim();
    if (newKeyword && !tags.includes(newKeyword)) {
      setFormData(prev => ({
        ...prev,
        [field.name]: [...(Array.isArray(prev[field.name]) ? prev[field.name] : []), newKeyword]
      }));
      setCurrentKeywordInput('');
    }
  };

  const handleRemoveKeyword = (keywordToRemove) => {
    setFormData(prev => ({
      ...prev,
      [field.name]: (Array.isArray(prev[field.name]) ? prev[field.name] : []).filter(tag => tag !== keywordToRemove)
    }));
   };

  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-2">
        <input
          type="text"
          value={currentKeywordInput}
          onChange={handleKeywordInputChange}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddKeyword();
            }
          }}
          className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] placeholder-gray-500"
          placeholder={field.placeholder || "Add a keyword and press Enter or click Add"}
        />
        <button
          type="button"
          onClick={() => handleAddKeyword()}
          className="px-4 py-2 bg-[#bb1ccc] text-white rounded-md hover:bg-[#000080] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Add
        </button>
      </div>

      <div className="flex flex-wrap gap-2 mb-2">
        {tags.map((tag, index) => (
          <span
            key={tag}
            className={`${tagColors[index % tagColors.length]} px-3 py-1 rounded-full text-sm flex items-center gap-1`}
          >
            {tag}
            <button
              type="button"
              onClick={() => handleRemoveKeyword(tag)}
              className="ml-1 text-inherit hover:text-[#000080] focus:outline-none"
            >
              &times;
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default KeywordInput; 